import { Component, OnInit } from '@angular/core';
import { RoutingStateService } from 'src/app/core/services/routing-state/routing-state.service';
import { environment } from 'src/environments/environment';
import { TabService } from 'src/app/tabs/services/tab.service';

@Component({
  selector: 'app-500',
  templateUrl: './500.component.html',
  styleUrls: ['./500.component.scss']
})
export class InternalErrorComponent implements OnInit {

  constructor(private routingStateService: RoutingStateService,private tabService: TabService) { }

  ngOnInit() {
  }

  goBack(){
    let baseRef = environment.server;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }

    let returnUrl = this.routingStateService.getPreviousUrlBeforeError();

    let index = this.routingStateService.getTabIndex('/error/500');

    if(index)
      this.tabService.removeTab(index);

    window.location.href = baseRef + 'web/#' + returnUrl;

  }

}
